var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card h-100"},[_vm._m(0),_c('div',{staticClass:"p-3 card-body"},[_c('div',{staticClass:"chart"},[_c('canvas',{staticClass:"chart-canvas",attrs:{"id":_vm.chartId,"height":"300"}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3 pb-0 card-header"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('h6',{staticClass:"mb-0"},[_vm._v("Sales by Age")])])])
}]

export { render, staticRenderFns }